import gql from 'graphql-tag';

export const FETCH_SUBSIDIZED_STUDENTS_QUERY = gql`
  query FetchSubsidizedStudents($organization: ID!) {
    subsidizedStudents(_organization: $organization) {
      _id
      user {
        _id
        first
        last
      }
      subsidies {
        subsidy { _id name }
        status
        requestedAt { timestamp }
      }
      lastSubsidyTransaction {
        _id
        createdAt { timestamp }
      }
    }
  }
`;

export const APPROVE_STUDENT_SUBSIDY_MUTATION = gql`
  mutation ApproveStudentSubsidy($student: ID!, $subsidy: ID!) {
    studentSubsidyApprove(_student: $student, _subsidy: $subsidy) {
      _id
    }
  }
`;

export const SUBSIDY_CREDITS_PURCHASE_MUTATION = gql`
  mutation SubsidyCreditsPurchase($organization: ID!, $amount: Int!, $token: String) {
    subsidyCreditsPurchase(_organization: $organization, amount: $amount, token: $token)
  }
`;

export const ADMIN_CHANGE_DEFAULT_CARD_MUTATION = gql`
  mutation adminChangeDefaultCard($card: ID!) {
    adminChangeDefaultCard(card: $card) {
      _id
    }
  }
`;

export const CREATE_SUBSIDY_MUTATION = gql`
  mutation CreateSubsidy($organization: ID!, $name: String!, $description: String!, $autoApprove: Boolean!, $image: String) {
    subsidyCreate(_organization: $organization, name: $name, description: $description, autoApprove: $autoApprove, image: $image) {
      _id
    }
  }
`;

export const EDIT_SUBSIDY_MUTATION = gql`
  mutation EditSubsidy($organization: ID!, $subsidy: ID!, $name: String, $description: String, $autoApprove: Boolean, $image: String) {
    subsidyEdit(_organization: $organization, _subsidy: $subsidy, name: $name, description: $description, autoApprove: $autoApprove, image: $image) {
      _id
    }
  }
`;

export const REJECT_STUDENT_SUBSIDY_MUTATION = gql`
  mutation RejectStudentSubsidy($student: ID!, $subsidy: ID!) {
    studentSubsidyReject(_student: $student, _subsidy: $subsidy) {
      _id
    }
  }
`;

export const ADD_SUBSIDY_STUDENTS_MUTATION = gql`
  mutation AddSubsidyStudents($subsidy: ID!, $students: [ID]!) {
    subsidyAddStudents(_subsidy: $subsidy, students: $students)
  }
`;

export const REMOVE_SUBSIDY_STUDENTS_MUTATION = gql`
  mutation RemoveSubsidyStudents($subsidy: ID!, $students: [ID]!) {
    subsidyRemoveStudents(_subsidy: $subsidy, students: $students)
  }
`;

export const DISTRIBUTE_SUBSIDY_CREDITS_MUTATION = gql`
  mutation DistributeSubsidyCredits($subsidy: ID!, $organization: ID!, $students: [SubsidyCreditStudentDistributionInput]!) {
    subsidyCreditsDistribute(_subsidy: $subsidy, _organization: $organization, students: $students)
  }
`;

export const ADD_SUBSIDY_CREDITS_MUTATION = gql`
  mutation AddSubsidyCredits($student: ID!, $subsidy: ID!, $amount: Int!, $currency: String!, $token: String!) {
    addSubsidyCredits(_student: $student, _subsidy: $subsidy, amount: $amount, currency: $currency, token: $token)
  }
`;

export const STUDENT_SUBSIDY_APPROVE_MUTATION = gql`
  mutation StudentSubsidyApprove($subsidy: ID!, $students: [ID!]!) {
    studentSubsidyApprove(_subsidy: $subsidy, students: $students) {
      _id
    }
  }
`;

export const STUDENT_SUBSIDY_REJECT_MUTATION = gql`
  mutation StudentSubsidyReject($subsidy: ID!, $students: [ID!]!) {
    studentSubsidyReject(_subsidy: $subsidy, students: $students) {
      _id
    }
  }
`;

export const ADMIN_ADD_CARD_MUTATION = gql`
  mutation adminAddCard($organization: ID!, $token: String!) {
    adminAddCard(_organization: $organization, token: $token) {
      _id
    }
  }
`;

export const FETCH_STUDENT_SUBSIDY_TRANSACTIONS_QUERY = gql`
  query fetchStudentSubsidyTransactions($student: ID!) {
    studentSubsidyTransactions(_student: $student) {
      _id
      amount
      subsidy {
        _id
        name
      }
      createdAt { timestamp }
    }
  }
`;

export const SUBSCRIBE_TO_SUBSIDY_SUBSCRIPTION = gql`
  subscription ($organizationIds: [ID]!) {
    subsidyAdded(organizationIds: $organizationIds) {
      _id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/subsidy/api.js